module.exports = __webpack_public_path__ + "img/v2.20eaa472.png";